const FETCH_CONTEST = 'contest/FETCH_CONTEST';

const POST_CONTEST_JOIN_MY_STORY = 'contest/POST_CONTEST_JOIN_MY_STORY';

const FETCH_CONTEST_JOIN_MY_STORY = 'contest/FETCH_CONTEST_JOIN_MY_STORY';

const POST_CONTEST_COMPLETE = 'contest/POST_CONTEST_COMPLETE';

const FETCH_CONTEST_EVENT = 'contest/FETCH_CONTEST_EVENT';

const FETCH_CONTEST_STORY = 'contest/FETCH_CONTEST_STORY';

const POST_CONTEST_STORY_VOTE = 'contest/POST_CONTEST_STORY_VOTE';

const FETCH_CONTEST_RANKING = 'contest/FETCH_CONTEST_RANKING';

const FETCH_CONTEST_LEFT_VOTE_COUNT = 'contest/FETCH_CONTEST_LEFT_VOTE_COUNT';

const FETCH_CONTEST_STORY_REMIND = 'contest/FETCH_CONTEST_STORY_REMIND';

const POST_CONTEST_STORY_REMIND = 'contest/POST_CONTEST_STORY_REMIND';

const RESET = 'contest/RESET';

export default {
  FETCH_CONTEST,
  POST_CONTEST_JOIN_MY_STORY,
  FETCH_CONTEST_JOIN_MY_STORY,
  POST_CONTEST_COMPLETE,
  FETCH_CONTEST_EVENT,
  FETCH_CONTEST_STORY,
  POST_CONTEST_STORY_VOTE,
  FETCH_CONTEST_RANKING,
  FETCH_CONTEST_LEFT_VOTE_COUNT,
  FETCH_CONTEST_STORY_REMIND,
  POST_CONTEST_STORY_REMIND,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/events/contest/types.js